import {isEmptyObject} from 'jquery'

export const constructPayload = (products: any, productsData: any) => {
  const payload = {
    data: [] as any[],
    default_price: [] as any[],
  }
  products?.variants.forEach((variant: any, parentIndex: any) => {
    // Process price list changes
    variant.price_list.forEach((priceItem: any, priceIndex: any) => {
      const priceListId = priceItem.price_list_id
      const updatedPrice = priceItem[`price_${priceIndex + 1}`]
      // Get original price from productsData
      const originalPriceItem = productsData?.variants?.[parentIndex]?.price_list?.[priceIndex]
      const originalPrice = originalPriceItem?.[`price_${priceIndex + 1}`]
      // Check if price has changed and is not undefined
      if (updatedPrice !== undefined && updatedPrice !== originalPrice) {
        payload.data.push({
          variant_id: variant.variant_id,
          price_list_id: priceListId,
          price: updatedPrice,
        })
      }
    })
    // Process default price changes
    if (variant.variant_price !== undefined) {
      const originalVariantPrice = productsData?.variants?.[parentIndex]?.variant_price
      if (variant.variant_price !== originalVariantPrice) {
        payload.default_price.push({
          variant_id: variant.variant_id,
          price: variant.variant_price,
        })
      }
    }
  })
  // Process default price changes for the parent product
  if (products.default_price !== undefined) {
    const originalDefaultPrice = productsData?.default_price
    // Check if the product's default price has been updated
    if (products.default_price !== originalDefaultPrice) {
      payload.default_price.push({
        variant_id: null, // Use null for the parent product
        price: products.default_price,
      })
    }
  }
  return payload
}
export const nameMapping: any = {
  'Value Tier Price List': 'Value Tier',
  'Tier Pro Price List': 'Tier Pro',
  'Midwest Region Tier 2 Price List': 'Midwest Region Tier 2',
  'Midwest Region Tier Pro Price List': 'Midwest Region Tier Pro',
}
export function renamePriceLists(data: any): any {
  if (!data) return {}
  const updatedData = {...data}
  Object.keys(updatedData).forEach((key) => {
    if (nameMapping[updatedData[key].name]) {
      updatedData[key].name = nameMapping[updatedData[key].name]
    }
  })
  return updatedData
}
export function renamePriceListsForDropDown(
  data: {id: number; name: string}[]
): {id: number; name: string}[] {
  if (!Array.isArray(data)) return []
  return data.map((item) => ({
    ...item,
    name: nameMapping[item.name] || item.name,
  }))
}
export function formatPriceListName(name: string): string {
  if (name === '' || name === undefined) {
    return '-'
  }
  return nameMapping[name] || name
}
export const formatToLabelValue = (data: any) => {
  const result: any = []
  if (isEmptyObject(data)) return []
  if (Array.isArray(data)) {
    const formattedData = data.map((item) => ({
      label: item.tag,
      value: item.id,
    }))
    return result.concat(formattedData)
  }
  const formattedData = Object.entries(data).map(([tag, id]) => ({
    label: tag,
    value: id,
  }))
  return result.concat(formattedData)
}
export const formatToUsersValue = (data: any) => {
  const result: any = []
  if (isEmptyObject(data)) return []
  if (Array.isArray(data)) {
    const formattedData = data.map((item) => ({
      label: item.name,
      value: item.username,
    }))
    return result.concat(formattedData)
  }
  const formattedData = Object.entries(data).map(([name, username]) => ({
    label: name,
    value: username,
  }))
  return result.concat(formattedData)
}
export const formatToPriceListValue = (data: any) => {
  const result: any = []
  if (isEmptyObject(data)) return []
  if (Array.isArray(data)) {
    const formattedData = data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    return result.concat(formattedData)
  }
  const formattedData = Object.entries(data).map(([name, id]) => ({
    label: name,
    value: id,
  }))
  return result.concat(formattedData)
}
export const columns = [
  {key: 'parent_product_sku', label: 'SKU', isSorted: false, headerStyle: 'min-w-150px'},
  {
    key: 'parent_product_name',
    label: 'Product Name',
    isSorted: true,
    headerStyle: 'min-w-400px',
  },
  {
    key: 'price_list_name',
    label: 'Price list',
    isSorted: false,
    headerStyle: 'min-w-200px',
  },
  {key: 'old_price', label: 'Old Price', isSorted: true, headerStyle: 'min-w-125px'},
  {key: 'updated_price', label: 'New Price', isSorted: true, headerStyle: 'min-w-125px'},
  {key: 'updated_by', label: 'User', isSorted: false, headerStyle: 'min-w-175px'},
  {key: 'updated_at', label: 'Last update Date', isSorted: true, headerStyle: 'min-w-175px'},
]
// Columns definition
export const columnsForRules = [
  {key: 'distributor_name', label: 'DISTRO NAME', isSorted: true, headerStyle: 'min-w-150px'},
  {key: 'rule_name', label: 'RULE NAME', isSorted: true, headerStyle: 'min-w-150px'},
  {key: 'category_names', label: 'Category', isSorted: false, headerStyle: 'min-w-250px'},
  {key: 'product_count', label: 'PRODUCTS', isSorted: false, headerStyle: 'min-w-100px'},
  {key: 'created_at', label: 'CREATED DATE', isSorted: true, headerStyle: 'min-w-150px'},
  {key: 'updated_at', label: 'LAST UPDATED DATE', isSorted: true, headerStyle: 'min-w-200px'},
  {key: 'product_count', label: 'Status', isSorted: false, headerStyle: 'min-w-100px'},
  {
    key: 'sync',
    label: 'SYNC',
    isSorted: false,
    headerStyle: 'min-w-80px',
    style: 'justify-content-center',
  },
  {
    key: 'action',
    label: 'ACTION',
    isSorted: false,
    headerStyle: 'w-80px text-center',
    render: true,
  },
]
// Dummy data array
export const PriceListData = [
  {
    distributor_name: 'TCD',
    rule_name: 'TCD Price',
    product_count: 457,
    updated_at: '25 Oct 2023, 6:43 am',
    action: '...',
    status: '',
  },
  {
    distributor_name: 'MBD',
    rule_name: 'MBD Price',
    product_count: 690,
    updated_at: '15 Oct 2023, 5:43 am',
    action: '...',
    status: '',
  },
  {
    distributor_name: 'TCD',
    rule_name: 'Distro',
    product_count: 194,
    updated_at: '10 Oct 2023, 7:43 pm',
    action: '...',
    status: '',
  },
  {
    distributor_name: 'MBC',
    rule_name: 'Tier',
    product_count: 5000,
    updated_at: '1 Oct 2023, 5:43 am',
    action: '...',
    status: '',
  },
]
export const CreatePayload = (formData: any, Distributors: any) => {
  const payload = {
    distributor_id: Number(formData.distributor_id), // Convert to numeric
    rule_name: formData.rule_name,
    categories: formData.categories.map((category: {id: number; name: string}) => category.id),
    price_calculation: formData.price_calculation,
    price_group: Number(formData.price_group), // Convert to numeric
    markup_price: Number(formData.markup_price), // Convert to numeric
    distributor_name:
      Distributors.find((distributor: any) => distributor.value === formData.distributor_id)
        ?.label || '', // Map `distributor_name` based on `distributor_id`
  }
  return payload
}
export const dataToMultiSelectOptions = (data: any) => {
  const res: any = []
  data.forEach((i: any) => {
    res.push({
      value: i,
      label: i,
    })
  })
  return res
}
export const parseCustomerSpecificPriceData = (data: any) => {
  if (!data?.length) return []
  return data?.map((item: any) => ({
    ...item,
    id: `${item.product_id}:${item.customer_id}`, // Combine product_id and customer_id
  }))
}
export const samplePriceListCSVData = [
  {
    'Product name': 'Product A',
    SKU: 'SKU001',
    Wholesale: 100,
    'Value Tier Price List': 105,
    'Tier 1 Price List': 110,
    'Tier 2 Price List': 115,
    'Tier Pro Price List': 120,
    Distributor: 95,
    'TCD Warehouse': 90,
    'MVD Warehouse': 88,
    VIP: 85,
  },
  {
    'Product name': 'Product B',
    SKU: 'SKU002',
    Wholesale: 200,
    'Value Tier Price List': 210,
    'Tier 1 Price List': 220,
    'Tier 2 Price List': 230,
    'Tier Pro Price List': 240,
    Distributor: 190,
    'TCD Warehouse': 180,
    'MVD Warehouse': 175,
    VIP: 170,
  },
  {
    'Product name': 'Product C',
    SKU: 'SKU003',
    Wholesale: 300,
    'Value Tier Price List': 315,
    'Tier 1 Price List': 330,
    'Tier 2 Price List': 345,
    'Tier Pro Price List': 360,
    Distributor: 285,
    'TCD Warehouse': 270,
    'MVD Warehouse': 265,
    VIP: 255,
  },
]

export const priceListCsvConfig = {
  requiredHeaders: [
    'Product name',
    'SKU',
    'Wholesale',
    'Value Tier Price List',
    'Tier 1 Price List',
    'Tier 2 Price List',
    'Tier Pro Price List',
    'Distributor',
    'TCD Warehouse',
    'MVD Warehouse',
    'VIP',
  ],
  duplicates: {sku: false},
  isNullable: false,
  nullableColumns: [
    'Product name',
    'Wholesale',
    'Value Tier Price List',
    'Tier 1 Price List',
    'Tier 2 Price List',
    'Tier Pro Price List',
    'Distributor',
    'TCD Warehouse',
    'MVD Warehouse',
    'VIP',
  ],
  isReplaceable: true,
  replacePartially: true,
  isUseRequestedHeaderAsaKey: true,
  allowDuplicateRow: true,
  maxRows: 100,
  types: {
    sku: 'string',
    wholesale: 'positive-integer',
    'value tier price list': 'positive-integer',
    'tier 1 price list': 'positive-integer',
    'tier 2 price list': 'positive-integer',
    'tier pro price list': 'positive-integer',
    distributor: 'positive-integer',
    'tcd warehouse': 'positive-integer',
    'mvd warehouse': 'positive-integer',
    vip: 'positive-integer',
  },
  customErrors: {
    headerMismatch: () =>
      'The file you are trying to upload is not a valid CSV file. Please download a sample CSV for reference.',
    invalidFileType: () =>
      'The file you are trying to upload is not a valid CSV file. Please download a sample CSV for reference.',
    emptyCell: (rowNumber: number, headerName: string) =>
      `Row ${rowNumber}: ${headerName} is blank. Please enter a valid ${headerName}.`,
    duplicateData: (skuName: string, rowNumbers: number[]) =>
      `Row ${rowNumbers.join(', ')}: Duplicate SKU found. Each SKU must be unique.`,
    replacePartially:
      'The following SKU(s) already exist in the system. Do you want to proceed with overwriting these data?',
    maxRowsLimit: (currentRows: number, maxLimit: number) =>
      `The current CSV contains ${currentRows} Rows.
        The maximum allowed Rows are ${maxLimit} for a quick operation. Please reduce the number of Rows to proceed with the import.`,
    invalidDataType: (headerName: string, rowIndex: number) =>
      `Row ${rowIndex} ${headerName}: Price is not valid.`,
  },
}
export const dataToPriceListCSV = (data: any) => {
  const results: any = []
  data.forEach((item: any) => {
    results.push({
      SKU: item?.child_sku,
      Qty: item?.qty || 0,
    })
  })
  return results
}
export function transformPriceListData(data: any) {
  const PRICE_LIST_MAPPING: any = {
    1: 'Wholesale',
    4: 'Value Tier Price List',
    2: 'Tier 1 Price List',
    3: 'Tier 2 Price List',
    5: 'Distributor',
    6: 'TCD Warehouse',
    7: 'MVD Warehouse',
    9: 'VIP',
  }
  return data.map(({variants}: any) => {
    const variant = variants?.[0] || {}
    const row: any = {
      SKU: variant.variant_sku || '',
      Wholesale: '',
      'Value Tier Price List': '',
      'Tier 1 Price List': '',
      'Tier 2 Price List': '',
      'Tier Pro Price List': '',
      Distributor: '',
      'TCD Warehouse': '',
      'MVD Warehouse': '',
      VIP: '',
    }
    variant.price_list?.forEach((p: any) => {
      const label = PRICE_LIST_MAPPING[p.price_list_id]
      if (label) {
        const priceValue =
          p.price ||
          p.amount ||
          Object.values(p).find(
            (v) => (typeof v === 'number' || (typeof v === 'string' && v)) && v !== ''
          )
        if (priceValue !== undefined) row[label] = priceValue
      }
    })
    return row
  })
}
export const updateDefaultColumnsWithMonths = (
  monthMap: Record<string, string>,
  priceListMap: Record<string, {name: string; active: boolean}>,
  roleId: any
) => {
  const monthColumns = monthMap
    ? Object.entries(monthMap)
        ?.map(([key, value]) => ({
          [key]: value,
        }))
        ?.reverse()
    : []
  const priceListColumns = Object.entries(priceListMap)
    .filter(([_, value]) => value.active)
    .map(([key, value]) => ({
      [key]: value.name,
    }))
  const baseColumns = [
    {product_name: 'Product Name', default: true},
    {sku: 'SKU', default: true},
    {classification: 'Classification'},
    {inventory_level: 'Current Stock'},
    ...(roleId !== '67f5f9c43c97938e59357472' &&
    roleId !== '67fd12676af694b36923ce09' &&
    roleId !== '67f92d2959074bcfeb4ff75a'
      ? [{cost: 'Cost', default: true}]
      : []),
    {default_price: 'Wholesale'},
    // priceListColumns will be inserted here
    // monthColumns will be inserted here
    ...(roleId !== '67fd12676af694b36923ce09'
      ? [{weeks_on_hand: 'Weeks On Hand'}, {turn_rate: 'Turn Rate'}]
      : []),
    {purchaser: 'PURCHASER'},
    ...(roleId !== '67fd12676af694b36923ce09' ? [{primary_supplier: 'SUPPLIER'}] : []),
    {updated_by: 'Last Updated By'},
    {created_date: ' Date Created'},
    {updated_at: 'Last Update Date'},
  ]
  // Find where to insert price and month columns (before updated_by)
  const insertIndex = baseColumns.findIndex((col) => Object.keys(col)[0] === 'default_price') + 1
  const updatedColumns = [
    ...baseColumns.slice(0, insertIndex),
    ...priceListColumns,
    {customer_specific_price: 'CSP'},
    ...monthColumns,
    ...baseColumns.slice(insertIndex),
  ]
  return updatedColumns
}
export const isColumnVisible = (key: string, columns: any) => {
  if (!Array.isArray(columns)) {
    return false
  }
  return columns.some((col: any) => Object.keys(col)[0] === key)
}

export const productCSPListModalTableColumns = [
  {key: 'customer_name', label: 'Customer', isSorted: false, headerStyle: 'min-w-150px'},
  {
    key: 'customer_group',
    label: 'Customer Group',
    isSorted: false,
    headerStyle: 'min-w-200px',
  },
  {key: 'company', label: 'Company', isSorted: false, headerStyle: 'min-w-200px'},
  {key: 'sales_rep', label: 'Sales Rep', isSorted: false, headerStyle: 'min-w-175px'},
  {key: 'price', label: 'Price', isSorted: false, headerStyle: 'min-w-120px', style: 'justify-content-end'},
]
